import { useState } from "react";
import { Trash2 } from "lucide-react";

export function deText(field) {
  if (field == null) return "";
  if (typeof field === "string") return field;
  if (typeof field === "object") return field.de || "";
  return String(field);
}

export function TextField({ label, value, onChange, placeholder, testid, required }) {
  return (
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-2)]">
        {label}
        {required && <span className="text-[var(--gold)] ml-1">*</span>}
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className="mt-2 w-full bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-2 text-[var(--text-0)] text-sm"
      />
    </label>
  );
}

export function TextAreaField({ label, value, onChange, placeholder, testid, rows = 4, required }) {
  return (
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-2)]">
        {label}
        {required && <span className="text-[var(--gold)] ml-1">*</span>}
      </span>
      <textarea
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className="mt-2 w-full bg-transparent border hairline focus:border-[var(--gold)] outline-none p-3 text-[var(--text-0)] text-sm resize-y"
      />
    </label>
  );
}

export function RepeatableStrings({ label, items, onChange, placeholder, testid }) {
  const set = (i, v) => {
    const next = [...items];
    next[i] = v;
    onChange(next);
  };
  const add = () => onChange([...items, ""]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-2)]">{label}</span>
        <button type="button" onClick={add} data-testid={`${testid}-add`} className="text-xs text-[var(--gold)] hover:underline">
          + Hinzufügen
        </button>
      </div>
      <div className="space-y-2">
        {items.map((v, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              type="text"
              value={v}
              onChange={(e) => set(i, e.target.value)}
              placeholder={placeholder}
              data-testid={`${testid}-${i}`}
              className="flex-1 bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-1.5 text-[var(--text-0)] text-sm"
            />
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`${testid}-remove-${i}`}
              className="text-[var(--text-3)] hover:text-red-500 shrink-0"
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {items.length === 0 && <div className="text-xs text-[var(--text-3)]">Noch keine Einträge.</div>}
      </div>
    </div>
  );
}

export function TagsField({ label, value, onChange, placeholder, testid }) {
  const [text, setText] = useState(() => (value || []).join(", "));
  return (
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-2)]">{label} (Komma-getrennt)</span>
      <input
        type="text"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          onChange(e.target.value.split(",").map((s) => s.trim()).filter(Boolean));
        }}
        placeholder={placeholder}
        data-testid={testid}
        className="mt-2 w-full bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-2 text-[var(--text-0)] text-sm"
      />
    </label>
  );
}
